import resources from './resources';

export const CHANGE_CONVO = 'CHANGE_CONVERSATION';
export const CONVO_DETAILS = 'CONVO_DETAILS';
export const OFF_LOADING_THREAD = 'OFF_LOADING_THREAD';
export const OFF_LOADING_CONVO = 'OFF_LOADING_CONVO';
export const UPDATE_THREADS = 'UPDATE_THREADS';
export const UPDATE_CONVO = 'UPDATE_CONVO';
export const UPDATE_CONTACT = 'UPDATE_CONTACT';
export const UPDATE_NAME = 'UPDATE_NAME';
export const GET_CONVO = 'GET_CONVO';
export const GET_CONVOS = 'GET_CONVOS';
export const ASSIGN_OLD_CONVO = 'ASSIGN_OLD_CONVO';
export const RESET_CONVOS = 'RESET_CONVOS';
export const RESET_THREAD= 'RESET_THREAD';
export const SET_CONTACT = 'SET_CONTACT';
export const THREAD_UPDATE = 'THREAD_UPDATE';
export const CONVO_UPDATE = 'CONVO_UPDATE';
export const FILTER_CONVO_LIST = 'FILTER_CONVO_LIST';
export const RECEIVE_MSG = 'RECEIVE_MSG';
export const SET_INBOX_STATE = 'SET_INBOX_STATE';
export const SEND_LIMIT_REACHED = 'SEND_LIMIT_REACHED';

export function sendLimitReached(data) {
	return async dispatch => {
		dispatch({
			type: SEND_LIMIT_REACHED,
			data
		});
	}
}

export function receiveMsg(data) {
	return async dispatch => {
		dispatch({
			type: RECEIVE_MSG,
			data
		});
	};
}

export function setInboxState(data) {
	return async dispatch => {
		dispatch({
			type: SET_INBOX_STATE,
			data
		});
	}
}

export function setContact(contact) {
	return async dispatch => {
		dispatch({
			type: SET_CONTACT,
			contact,
		});
	};
}

export function filterConvoList(data) {
	return async dispatch => {
		dispatch({
			type: FILTER_CONVO_LIST,
			data,
		});
	};
}

export function threadUpdate(thread) {
	return async dispatch => {
		dispatch({
			type: THREAD_UPDATE,
			thread,
		});
	};
}

export function convoUpdate(contact) {
	return async dispatch => {
		dispatch({
			type: CONVO_UPDATE,
			contact,
		});
	};
}

export function changeConvo(id) {
	return dispatch => {
		dispatch({
			type: CHANGE_CONVO,
			id,
		});
	};
}

export function setConvoDetails(body) {
	return dispatch => {
		dispatch({
			type: CONVO_DETAILS,
			body,
		});
	};
}

export function toggleThreadsLoading(status) {
	return dispatch => {
		dispatch({
			type: OFF_LOADING_THREAD,
			status,
		});
	};
}

export function toggleConvoLoading(status) {
	return dispatch => {
		dispatch({
			type: OFF_LOADING_CONVO,
			status,
		});
	};
}

export function updateConvo(convo) {
	return async dispatch => {
		dispatch({
			type: UPDATE_CONVO,
			convo,
		});
	};
};

export function updateThreads(thread) {
	return async dispatch => {
		dispatch({
			type: UPDATE_THREADS,
			thread,
		});
	};
};

export function updateContact(contact) {
	return async dispatch => {
		dispatch({
			type: UPDATE_CONTACT,
			contact,
		});
	};
};

export function updateName(name) {
	return async dispatch => {
		dispatch({
			type: UPDATE_NAME,
			name,
		});
	};
};

export function filterConvo(botId, deptName) {
	return async dispatch => {
		let convo;
		let api;

		if (deptName) {
			convo = await resources.getConvoByDepts('limit=20&next=0', botId);
			api = ['getConvoByDepts', botId];
		} else {
			convo = await resources.getConvoByBots('limit=20&next=0', botId);
			api = ['getConvoByBots', botId];
		}

		dispatch({
			type: GET_CONVO,
			convo,
			api,
		});
	}
}

export function getAllConvo() {
	return async dispatch => {
		let convos = await resources.getAllConversations('limit=20&next=0');

		dispatch({
			type: GET_CONVOS,
			api: ['getAllConversations'],
			convos,
		});
	}
}

export function assignOldConvo(id) {
	return dispatch => {
		dispatch({
			type: ASSIGN_OLD_CONVO,
			id,
		});
	};
}

export function resetConvos() {
	return dispatch => {
		dispatch({
			type: RESET_CONVOS
		});
	};
}

export function resetThread() {
	return dispatch => {
		dispatch({
			type: RESET_THREAD
		});
	};
}